import { gql } from '@apollo/client'

export const FIND_ALL_RECOMMENDED_ARTICLE_GROUP = gql`
  query findAllRecommendedArticleGroup($query: RecommendedArticleGroupQueryInput!) {
    findAllRecommendedArticleGroup(query: $query) {
      count
      items {
        id
        title
        description
        color
        order
        icon
      }
    }
  }
`

export const CREATE_RECOMMENDED_ARTICLE_GROUP = gql`
  mutation createRecommendedArticleGroup($createRecommendedArticleGroupInput: CreateRecommendedArticleGroupInput!) {
    createRecommendedArticleGroup(createRecommendedArticleGroupInput: $createRecommendedArticleGroupInput) {
      id
      title
      description
      color
      order
      icon
    }
  }
`

export const REMOVE_RECOMMENDED_ARTICLE_GROUP = gql`
  mutation removeRecommendedArticleGroup($removeRecommendedArticleGroupId: String!) {
    removeRecommendedArticleGroup(id: $removeRecommendedArticleGroupId) {
      affected
    }
  }
`

export const UPDATE_RECOMMENDED_ARTICLE_GROUP = gql`
  mutation updateRecommendedArticleGroup(
    $updateRecommendedArticleGroupInputFieldName: UpdateRecommendedArticleGroupInput!
  ) {
    updateRecommendedArticleGroup(
      updateRecommendedArticleGroupInputFieldName: $updateRecommendedArticleGroupInputFieldName
    ) {
      id
    }
  }
`

export const BULK_UPDATE_RECOMMENDED_ARTICLE_GROUP = gql`
  mutation bulkUpdateRecommendedArticleGroup(
    $bulkUpdateRecommendedArticleGroupInput: [BulkUpdateRecommendedArticleGroupInput!]!
  ) {
    bulkUpdateRecommendedArticleGroup(bulkUpdateRecommendedArticleGroupInput: $bulkUpdateRecommendedArticleGroupInput) {
      id
    }
  }
`

export const BULK_REMOVE_RECOMMENDED_ARTICLE_GROUP = gql`
  mutation BulkRemoveRecommendedArticleGroup($ids: [LinkRecommendedArticleGroupInput!]!) {
    bulkRemoveRecommendedArticleGroup(ids: $ids) {
      affected
    }
  }
`
